"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var FC2 = /** @class */function () {
  /**
   * Constructor for FC2 class
   */
  function FC2() {
    this.events = {};
    this.config = {
      readMoreLink: '',
      readMoreLabel: '',
      banner: {
        title: '',
        description: '',
        acceptAllLabel: '',
        declineAllLabel: '',
        customizeLabel: ''
      },
      modal: {
        title: '',
        description: '',
        acceptAllLabel: '',
        declineAllLabel: '',
        submitLabel: ''
      },
      sections: []
    };
    this.acceptKey = 'accept';
    this.declineKey = 'decline';
    this.bannerId = 'fc2-banner';
    this.modalId = 'fc2-modal';
    this.toggleClass = 'fc2-js-toggle';
    this.checkboxClass = 'fc2-js-checkbox';
    this.cookieName = 'fc2';
    this.cookieExpiresDays = 90;
    this.bannerInjected = false;
    this.modalInjected = false;
    this.state = {};
  }
  /**
   * Listen for a event called `eventName` and execute the `fn` callback function
   */
  FC2.prototype.on = function (eventName, fn) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(fn);
  };
  /**
   * Emit the event called `eventName` with optional `data`.
   * This calls every `fn` callback function registered
   * for event `eventName`
   */
  FC2.prototype.emit = function (eventName, data) {
    if (data === void 0) {
      data = {};
    }
    var event = this.events[eventName];
    if (event) {
      event.forEach(function (fn) {
        fn.call(null, data);
      });
    }
  };
  /**
   * Execute the `fn` callback function when the service matching `serviceKey` is Accepted
   */
  FC2.prototype.onAccept = function (serviceKey, fn) {
    this.on("".concat(serviceKey, ":").concat(this.acceptKey), fn);
  };
  /**
   * Execute the `fn` callback function when the service matching `serviceKey` is Declined
   */
  FC2.prototype.onDecline = function (serviceKey, fn) {
    this.on("".concat(serviceKey, ":").concat(this.declineKey), fn);
  };
  /**
   * Emit the Accept event for the service matching `serviceKey`
   */
  FC2.prototype.emitAccept = function (serviceKey) {
    var data = this.getService(serviceKey);
    this.emit("".concat(serviceKey, ":").concat(this.acceptKey), data);
  };
  /**
   * Emit the Decline event for the service matching `serviceKey`
   */
  FC2.prototype.emitDecline = function (serviceKey) {
    var data = this.getService(serviceKey);
    this.emit("".concat(serviceKey, ":").concat(this.declineKey), data);
  };
  /**
   * Emit all Decline and Accept events from the state's values
   */
  FC2.prototype.emitEventsFromState = function () {
    var _this = this;
    Object.keys(this.state).forEach(function (key) {
      if (_this.state[key]) {
        _this.emitAccept(key);
      } else {
        _this.emitDecline(key);
      }
    });
  };
  /**
   * Retrieve info for service matching serviceKey
   */
  FC2.prototype.getService = function (serviceKey) {
    var result = {};
    this.config.sections.forEach(function (section) {
      section.services.forEach(function (service) {
        if (service.key === serviceKey) {
          result = service;
        }
      });
    });
    return result;
  };
  /**
   * load script and stylesheet utils
   */
  FC2.loadScript = function (url, async) {
    if (async === void 0) {
      async = true;
    }
    var head = document.head;
    var script = document.createElement('script');
    script.async = async;
    script.src = url;
    head.appendChild(script);
  };
  /**
   * Init FC2 with config
   */
  FC2.prototype.init = function (config) {
    var _this = this;
    this.config = _extends(this.config, config);
    if (document.readyState === "complete") {
      this.setStateFromCookie();
      if (!this.wasSubmited()) {
        this.showBanner();
      }
    } else {
      window.addEventListener('load', function () {
        _this.setStateFromCookie();
        if (!_this.wasSubmited()) {
          _this.showBanner();
        } else {
          console.log('show button');
          _this.showButton();
        }
      });
    }
  };
  /**
   * Convert an HTML string into a ChildNode
   */
  FC2.htmlToChildNode = function (html) {
    var template = document.createElement('template');
    var cleanedHtml = html.trim();
    template.innerHTML = cleanedHtml;
    if (template.content) {
      return template.content.firstChild;
    } else {
      return template.firstChild;
    }
  };
  /**
   * Inject Banner into DOM
   */
  FC2.prototype.injectBanner = function () {
    var bannerElement = FC2.htmlToChildNode("\n      <div class=\"fc2-banner fc2-wrapper\" id=\"".concat(this.bannerId, "\">\n      <div class=\"fc2-header\">\n        <p class=\"fc2-title\">").concat(this.config.banner.title, "</p>\n      </div>\n      <div class=\"fc2-body\">\n        <p>").concat(this.config.banner.description, "</p>\n        <a class=\"fc2-link\" href=\"").concat(this.config.readMoreLink, "\">").concat(this.config.readMoreLabel, "</a>\n        <hr>\n      </div>\n      <div class=\"fc2-footer\">\n        <button class=\"fc2-button\" id=\"customize\">").concat(this.config.banner.customizeLabel, "</button>\n        <button class=\"fc2-button\" id=\"decline\">").concat(this.config.banner.declineAllLabel, "</button>\n        <button class=\"fc2-button\" id=\"accept\">").concat(this.config.banner.acceptAllLabel, "</button>\n      </div>\n      </div>\n    "));
    if (bannerElement) {
      document.body.appendChild(bannerElement);
      var customize = this.getCustomizeBannerButtonElement(),
        decline = this.getDeclineBannerButtonElement(),
        accept = this.getAcceptBannerButtonElement();
      if (customize && decline && accept) {
        customize.addEventListener('click', function (e) {
          fc2.showModal();
          fc2.hideBanner();
        });
        decline.addEventListener('click', function (e) {
          fc2.declineAll();
          fc2.hideBanner();
          fc2.showButton();
        });
        accept.addEventListener('click', function (e) {
          fc2.acceptAll();
          fc2.hideBanner();
          fc2.showButton();
        });
      }
    }
  };
  /**
   * Get HTML string for services
   */
  FC2.prototype.getServicesHTML = function (services) {
    var _this = this;
    var servicesHTML = services.map(function (service) {
      var checked = _this.state[service.key] ? ' checked' : '';
      return "\n        <li class=\"fc2-collapse-item\">\n          <div class=\"fc2-collapse-header\">\n            <p class=\"fc2-title ".concat(_this.toggleClass, "\"><span class=\"fc2-collapse-icon\"></span>").concat(service.title, "</p>\n            <div class=\"fc2-switch\">\n              <input type=\"checkbox\" name=\"").concat(service.key, "\"").concat(checked, " class=\"").concat(_this.checkboxClass, "\">\n              <div class=\"fc2-switch-label\"></div>\n            </div>\n          </div>\n          <div class=\"fc2-collapse-body\">\n            <p>").concat(service.description, "</p>\n          </div>\n        </li>\n      ");
    });
    return servicesHTML.join('\n');
  };
  /**
   * Get HTML string for sections
   */
  FC2.prototype.getSectionsHTML = function () {
    var _this = this;
    var sectionsHTML = this.config.sections.map(function (section) {
      var services = _this.getServicesHTML(section.services);
      return "\n        <li class=\"fc2-list-item\">\n          <div class=\"fc2-list-header\">\n            <p class=\"fc2-title\">".concat(section.title, "</p>\n          </div>\n          <div class=\"fc2-list-body\">\n            <ul class=\"fc2-collapse\">\n              ").concat(services, "\n            </ul>\n          </div>\n        </li>\n      ");
    });
    return sectionsHTML.join('\n');
  };
  /**
   * Inject Modal into DOM
   */
  FC2.prototype.injectModal = function () {
    var modalElement = FC2.htmlToChildNode("\n      <div class=\"fc2-modal fc2-wrapper\" id=\"".concat(this.modalId, "\">\n        <div class=\"fc2-header\">\n          <p class=\"fc2-title\">").concat(this.config.modal.title, "</p>\n        </div>\n        <div class=\"fc2-header\">\n          <p>").concat(this.config.modal.description, "</p>\n        </div>\n        <div class=\"fc2-body\">\n          <ul class=\"fc2-list\">\n            ").concat(this.getSectionsHTML(), "\n          </ul>\n          <a class=\"fc2-link\" href=\"").concat(this.config.readMoreLink, "\">").concat(this.config.readMoreLabel, "</a>\n          <hr>\n        </div>\n        <div class=\"fc2-footer\">\n          <button class=\"fc2-button\" id=\"accept_modal\">").concat(this.config.modal.acceptAllLabel, "</button>\n          <button class=\"fc2-button\" id=\"decline_modal\">").concat(this.config.modal.declineAllLabel, "</button>\n          <button class=\"fc2-button\" id=\"submit_modal\">").concat(this.config.modal.submitLabel, "</button>\n        </div>\n      </div>\n    "));
    if (modalElement) {
      document.body.appendChild(modalElement);
      var accept_modal = this.getAcceptModalButtonElement(),
        decline_modal = this.getDeclineModalButtonElement(),
        submit_modal = this.getSubmitModalButtonElement();
      if (accept_modal && decline_modal && submit_modal) {
        accept_modal.addEventListener('click', function (e) {
          fc2.acceptAll();
          fc2.hideModal(500);
          fc2.showButton();
        });
        decline_modal.addEventListener('click', function (e) {
          fc2.declineAll();
          fc2.hideModal(500);
          fc2.showButton();
        });
        submit_modal.addEventListener('click', function (e) {
          fc2.submit();
          fc2.hideModal(500);
          fc2.showButton();
        });
      }
    }
    this.bindItemToggle();
  };
  /**
   * Bind click on services to display/hide description
   */
  FC2.prototype.bindItemToggle = function () {
    var itemElements = document.getElementsByClassName(this.toggleClass);
    // we use a basic for loop insteand of Array.from to keep compatibility with old browsers
    for (var i = 0; i < itemElements.length; i++) {
      itemElements[i].addEventListener('click', function () {
        if (this.parentNode && this.parentNode.parentNode) {
          this.parentNode.parentNode.classList.toggle('active');
        }
      });
    }
  };
  /**
   * Return banner HTMLElement
   */
  FC2.prototype.getBannerElement = function () {
    return document.getElementById(this.bannerId);
  };
  FC2.prototype.getCustomizeBannerButtonElement = function () {
    return document.getElementById('customize');
  };
  FC2.prototype.getAcceptBannerButtonElement = function () {
    return document.getElementById('accept');
  };
  FC2.prototype.getShowBannerButtonElement = function () {
    return document.getElementById('show-banner');
  };
  FC2.prototype.getDeclineBannerButtonElement = function () {
    return document.getElementById('decline');
  };
  /**
   * Return modal HTMLElement
   */
  FC2.prototype.getModalElement = function () {
    return document.getElementById(this.modalId);
  };
  FC2.prototype.getAcceptModalButtonElement = function () {
    return document.getElementById('accept_modal');
  };
  FC2.prototype.getDeclineModalButtonElement = function () {
    return document.getElementById('decline_modal');
  };
  FC2.prototype.getSubmitModalButtonElement = function () {
    return document.getElementById('submit_modal');
  };
  /**
   * Show button
   */
  FC2.prototype.injectButton = function () {
    var buttonElement = FC2.htmlToChildNode("\n      <button class=\"fc2-button fc2-button-show\" id=\"show-banner\">\n        <svg width=\"614\" height=\"718\" viewBox=\"0 0 614 718\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.30908 417.761C-23.2399 232.628 84.6021 80.7443 229.871 24.7779C381.233 -33.6256 533.639 20.6 613.28 106.769L550.699 169.351C480.98 103.549 399.25 78.4813 306.292 96.5855C236.225 110.251 180.171 148.2 139.785 207.213C55.2697 330.809 92.5227 479.733 179.388 555.632C179.492 554.659 179.638 553.77 179.776 552.931C179.983 551.667 180.171 550.516 180.171 549.365C180.204 525.571 180.2 501.777 180.196 477.983C180.189 438.325 180.182 398.668 180.346 359.01C180.607 297.995 206.283 249.427 254.938 213.48C288.623 188.586 327.268 177.619 369.134 179.882C443.988 183.973 506.918 231.758 530.592 302.173C541.559 334.813 543.3 368.323 534.422 401.833C514.751 476.165 466.096 520.903 391.677 536.309C355.295 543.882 318.999 538.92 284.88 522.818C282.894 521.915 280.908 520.989 278.715 519.967C276.68 519.017 274.467 517.985 271.911 516.812C271.793 518.282 271.656 519.643 271.526 520.934C271.27 523.467 271.041 525.735 271.041 528.04C270.867 583.223 270.867 638.406 270.867 693.589V706.21C149.795 679.228 28.6357 569.384 5.30908 417.761ZM448.949 359.88C450.69 312.008 409.259 270.752 360.952 270.403H361.04C316.649 270.055 271.65 304.958 271.389 359.532C271.128 408.709 310.383 448.225 360.169 448.399C413.35 448.66 450.777 403.4 448.949 359.88ZM357.385 717.961L356.515 628.136C429.541 626.656 492.21 600.544 544.172 550.497L607.624 613.948C576.638 645.457 540.429 670.002 499.695 687.932C454.347 707.864 406.911 718.744 357.385 717.961Z\" fill=\"white\"/>\n        </svg>\n        <span>ookies</span>\n      </button>\n    ");
    if (buttonElement) {
      document.body.appendChild(buttonElement);
    }
    var show = this.getShowBannerButtonElement();
    if (show) {
      show.addEventListener('click', function (e) {
        console.log('show clicked');
        fc2.hideButton();
        fc2.showBanner();
      });
    }
  };
  ;
  FC2.prototype.showButton = function () {
    // this.injectButton();
    var buttonElement = this.getShowBannerButtonElement();
    setTimeout(function () {
      if (buttonElement) {
        buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.add('active');
      }
    }, 300);
  };
  /**
   * Hide button
   */
  FC2.prototype.hideButton = function () {
    var buttonElement = this.getShowBannerButtonElement();
    if (buttonElement) {
      buttonElement.classList.remove('active');
    }
  };
  /**
   * Show banner
   */
  FC2.prototype.showBanner = function () {
    if (!this.bannerInjected) {
      this.injectBanner();
      this.bannerInjected = true;
    }
    var bannerElement = this.getBannerElement();
    setTimeout(function () {
      if (bannerElement) {
        bannerElement.classList.add('active');
      }
    }, 300);
  };
  /**
   * Hide banner
   */
  FC2.prototype.hideBanner = function () {
    var bannerElement = this.getBannerElement();
    if (bannerElement) {
      bannerElement.classList.remove('active');
    }
  };
  /**
   * Show modal
   */
  FC2.prototype.showModal = function () {
    if (!this.modalInjected) {
      this.injectModal();
      this.modalInjected = true;
    }
    var modalElement = this.getModalElement();
    setTimeout(function () {
      if (modalElement) {
        modalElement.classList.add('active');
      }
    }, 300);
  };
  /**
   * Hide modal
   */
  FC2.prototype.hideModal = function (timeout) {
    var _this = this;
    if (timeout === void 0) {
      timeout = 0;
    }
    setTimeout(function () {
      var modalElement = _this.getModalElement();
      if (modalElement) {
        modalElement.classList.remove('active');
      }
    }, timeout);
  };
  /**
   * Set FC2 cookie with given value
   */
  FC2.prototype.setCookie = function (value) {
    if (value === void 0) {
      value = '';
    }
    var date = new Date();
    date.setTime(date.getTime() + this.cookieExpiresDays * 24 * 60 * 60 * 1000);
    var expires = date.toUTCString();
    document.cookie = "".concat(this.cookieName, "=").concat(value, "; expires=").concat(expires, "; path=/");
  };
  /**
   * Delete FC2 cookie
   */
  FC2.prototype.deleteCookie = function () {
    var date = new Date();
    date.setTime(date.getTime() - 1 * 24 * 60 * 60 * 1000);
    var expires = date.toUTCString();
    document.cookie = "".concat(this.cookieName, "=; expires=").concat(expires, "; path=/");
  };
  /**
   * Get FC2 cookie value
   */
  FC2.prototype.getCookie = function () {
    var name = "".concat(this.cookieName, "=");
    var cookiesParts = document.cookie.split(';');
    var value = '';
    cookiesParts.forEach(function (cookiePart) {
      var cleanedCookiePart = cookiePart;
      while (cleanedCookiePart.charAt(0) === ' ') {
        cleanedCookiePart = cleanedCookiePart.substring(1, cookiePart.length);
      }
      if (cleanedCookiePart.indexOf(name) === 0) {
        value = cleanedCookiePart.substring(name.length, cleanedCookiePart.length);
      }
    });
    return value;
  };
  /**
   * Retrieve value from Cookie
   * and set it on the `state` property
   */
  FC2.prototype.setStateFromCookie = function () {
    var cookieValue = this.getCookie();
    if (cookieValue) {
      this.state = cookieValue.split('|').reduce(function (prev, current) {
        var arr = current.split('=');
        prev[arr[0]] = !!+arr[1];
        return prev;
      }, {});
      this.emitEventsFromState();
    }
  };
  /**
   * Set value from the `state` property
   * to the cookie
   * Value is stored with the following format
   * `FooServiceKey=1|BarServiceKey=0|BazServiceKey=1`
   */
  FC2.prototype.setCookieFromState = function () {
    var _this = this;
    var cookieValue = Object.keys(this.state).reduce(function (prev, key) {
      var val = _this.state[key] ? 1 : 0;
      prev.push("".concat(key, "=").concat(val));
      return prev;
    }, []).join('|');
    this.setCookie(cookieValue);
    this.emitEventsFromState();
  };
  /**
   * Return true is the modal was submitted by the user
   */
  FC2.prototype.wasSubmited = function () {
    return Object.keys(this.state).length > 0;
  };
  /**
   * Return true is the service matching serviceKey was accepted
   */
  FC2.prototype.isAccepted = function (serviceKey) {
    return this.state[serviceKey] || false;
  };
  /**
   * Return true is the service matching serviceKey was declined
   */
  FC2.prototype.isDeclined = function (serviceKey) {
    return !this.isAccepted(serviceKey);
  };
  /**
   * Accept all services
   */
  FC2.prototype.acceptAll = function () {
    var _this = this;
    var checkboxesElements = document.getElementsByClassName(this.checkboxClass);
    if (checkboxesElements.length > 0) {
      // we use a basic for loop insteand of Array.from to keep compatibility with old browsers
      for (var i = 0; i < checkboxesElements.length; i++) {
        var key = checkboxesElements[i].getAttribute('name');
        checkboxesElements[i].checked = true;
        if (key) {
          this.state[key] = true;
        }
      }
    } else {
      this.config.sections.forEach(function (section) {
        section.services.forEach(function (service) {
          _this.state[service.key] = true;
        });
      });
    }
    this.setCookieFromState();
  };
  /**
   * Decline all services
   */
  FC2.prototype.declineAll = function () {
    var _this = this;
    var checkboxesElements = document.getElementsByClassName(this.checkboxClass);
    if (checkboxesElements.length > 0) {
      // we use a basic for loop insteand of Array.from to keep compatibility with old browsers
      for (var i = 0; i < checkboxesElements.length; i++) {
        var key = checkboxesElements[i].getAttribute('name');
        checkboxesElements[i].checked = false;
        if (key) {
          this.state[key] = false;
        }
      }
    } else {
      this.config.sections.forEach(function (section) {
        section.services.forEach(function (service) {
          _this.state[service.key] = false;
        });
      });
    }
    this.setCookieFromState();
  };
  /**
   * Submit choices in modal
   */
  FC2.prototype.submit = function (allTrue) {
    if (allTrue === void 0) {
      allTrue = false;
    }
    var checkboxesElements = document.getElementsByClassName(this.checkboxClass);
    // we use a basic for loop insteand of Array.from to keep compatibility with old browsers
    for (var i = 0; i < checkboxesElements.length; i++) {
      var key = checkboxesElements[i].getAttribute('name');
      var value = checkboxesElements[i].checked;
      if (key) {
        this.state[key] = value || allTrue;
      }
    }
    this.setCookieFromState();
  };
  return FC2;
}();
var fc2 = new FC2();